// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__Aue4v","Success":"Button_Success__dlur2","Danger":"Button_Danger__184sx"};